import { useTranslation } from "react-i18next";
import {
  ChallengeCardWrapper,
  ChallengeHeader,
  ChallengeAmount,
} from "./ChallengeUtils";
import ModalChallengeCancelled from "../../modals/ModalChallengeCancelled";
import { ChallengeInfoProps } from "@/pages/challenges/ChallengeInfo";

export const ChallengeCancelledCard = ({
  targetAmount,
  gainedAmount,
}: ChallengeInfoProps) => {
  const { t } = useTranslation();

  return (
    <ChallengeCardWrapper>
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <ChallengeHeader text={t("challenge.cancelled")} />
          </div>
          {targetAmount && <ChallengeAmount amount={targetAmount} />}
        </div>
      </div>
      {gainedAmount && targetAmount && (
        <ModalChallengeCancelled
          gainedDon={gainedAmount}
          targetDon={targetAmount}
        />
      )}
    </ChallengeCardWrapper>
  );
};
